import React from 'react';
import { useFragment, graphql, FragmentType } from '@frontend/gql/social';
import { formatNumber } from '../../../utils/formatNumber';
import { CardStat, CardStatLabel } from '../../../components/card-stat';

const postsMetricFragment = graphql(`
  fragment PostsMetric_TotalInsights on TotalInsights {
    numberOfPosts
  }
`);

type PostsMetricProps = {
  data: FragmentType<typeof postsMetricFragment> | null | undefined;
};

export const PostsMetric = ({ data }: PostsMetricProps) => {
  const totalInsights = useFragment(postsMetricFragment, data);
  const posts = totalInsights?.numberOfPosts ?? 0;

  return (
    <div className="flex flex-col items-start">
      <CardStatLabel>Posts</CardStatLabel>
      <CardStat className="text-xl leading-none">{formatNumber(posts)}</CardStat>
    </div>
  );
};
